import { CompanyStructure } from "@wingspanhq/users";
import { BUSINESS_COMPANY_STRUCTURE_SELECT_OPTIONS } from "../constants/member";

export const selectorTaxClassificationLabel = (value?: CompanyStructure) =>
  BUSINESS_COMPANY_STRUCTURE_SELECT_OPTIONS.find(
    option => option.value === value
  )?.label || "Sole proprietorship";
